import Vue from 'vue'
import Vuex from 'vuex'

import PlateEditor from './plate_editor'
import MetroEditor from './metro_editor'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    PlateEditor,
    MetroEditor
  },
  state: {
    roles: [],
    houses: [],
  },
  mutations: {
    setHouses(state, houses) {
      state.houses = houses
    },
    setRoles(state, roles) {
      state.roles = roles
    },
  },
  actions: {
    setHouses({ commit }, houses) {
      commit('setHouses', houses)
    },
    setRoles({ commit }, roles) {
      commit('setRoles', roles)
    },
  },
  getters: {
    getHouses: (state) => {
      return state.houses
    },
    getRoles: (state) => {
      return state.roles
    },
  },
})
